import { lineString, nearestPointOnLine, point } from "@turf/turf";
import React, { useEffect, useRef, useState, Fragment } from "react";
import { isNil, uniqBy } from "lodash";
import {
  GoogleMap,
  OverlayView,
  Polyline,
  withGoogleMap,
  Marker,
} from "react-google-maps";
import { compose, withProps } from "recompose";
import * as turf from "@turf/turf";
import { decode } from "@mapbox/polyline";
import Color from "color";

import Bus from "../../assets/school-bus.svg";

import { getColor } from "../../utils/api";
import { vehicleIconBg, vehicleIconCar } from "../../utils/utils";
import "./styles.scss";
const colors = [
  "green",
  "blue",
  "red",
  "yellow",
  "purple",
  "orange",
  "grey",
  "lightSalmon",
  "pink",
  "lightSeaGreen",
  "mintCream",
  "olive",
  "paleGreen",
  "rosyBrown",
  "slateBlue",
  "teal",
  "steelBlue",
  "moccasin",
  "linen",
  "indigo",
];
const MapComp = withGoogleMap((props) => {
  const map = useRef(null);
  const {
    path,
    bounds,
    stops,
    path2,
    stops2,
    court,
    vehicleLocations,
    vehicleLocations2,
    traffic,
    traffic2,
    vehicleLocationAlwaysShow,
    vehicleIconBearing,
    stopColor,
    vehicleColor,
    themeColour,
    focusStop,
    showLicensePlate
  } = props;
  const [canUpdateBound, setCanUpdateBound] = useState(true);
  const [cars, setCars] = useState([]);
  const [cars2, setCars2] = useState([]);

  const [isLoaded, setIsLoaded] = useState(false);
  const [carPaths, setCarPaths] = useState([]);
  const [trigger, setTrigger] = useState(false);
  const [focused, setFocused] = useState(false);

  useEffect(() => {
    if (map.current && canUpdateBound) {
      map.current.fitBounds(bounds, 10);
      setCanUpdateBound(false);
    }
  }, [bounds, canUpdateBound, map]);

  useEffect(() => {
    if (focusStop && !focused) {
      map.current.panTo({ lat: focusStop.coordinates.wgs84.latitude, lng: focusStop.coordinates.wgs84.longitude });
      console.log(map.current);
      map.current.zoom = 12;
      setFocused(true);
    }
  }, [focusStop]);

  useEffect(() => {
    if (vehicleLocations && path.length > 0) {
      const tempCars = uniqBy(Object.values(vehicleLocations), "license_plate")
        .map((el) => {
          const startPoint = [path[0].lng, path[0].lat];
          const pathLine = turf.lineString(path.map((el) => [el.lng, el.lat]));
          const currentLog = turf.point(el.coordinates);
          const logToLineDistance = turf.pointToLineDistance(
            currentLog,
            pathLine,
            {
              units: "meters",
            }
          );

          // check vehicle location is 100m away from polyline
          if (logToLineDistance < 150 && pathLine) {
            const pathLength = turf.length(pathLine, { units: "meters" });

            // if always show location ,dont bind to polyline
            if (vehicleLocationAlwaysShow
              //  && !el.progress
            ) {
              return {
                ...el,
                coordinates: turf.nearestPointOnLine(
                  pathLine,
                  point(el.coordinates)
                ).geometry.coordinates,
                path: pathLine.geometry.coordinates,
                bearing: el.bearing,
              };
            } else {
              if (el.progress) {
                // check if progress exists, then bind to ±25% (or param) of line
                const cappedProgress = Math.min(el.progress, pathLength);
                const start = cappedProgress - pathLength * 0.15;
                const end = cappedProgress + pathLength * 0.15;
                const slicedLine = turf.lineSliceAlong(
                  pathLine,
                  Math.max(0, start),
                  Math.min(end, pathLength),
                  { units: "meters" }
                );

                const tempCoor = turf.nearestPointOnLine(
                  slicedLine,
                  point(el.coordinates)
                );

                let index = tempCoor.properties.index;
                const slicedLength = slicedLine.geometry.coordinates.length - 1;
                if (index >= slicedLength - 1) {
                  index = slicedLength - 2;
                }

                const bearing =
                // el?.bearing || 
                turf.bearing(
                  tempCoor,
                  slicedLine.geometry.coordinates[index + 1]
                );

                return {
                  ...el,
                  coordinates: el.trip?.startTime ? tempCoor.geometry.coordinates : startPoint,
                  path: slicedLine.geometry.coordinates,
                  bearing,
                };
              } else {
                const tempCoor = turf.nearestPointOnLine(
                  pathLine,
                  point(el.coordinates)
                );
                return {
                  ...el,
                  coordinates: el.trip?.startTime ? tempCoor.geometry.coordinates : startPoint,
                  path: pathLine.geometry.coordinates,
                  bearing: null,
                };
              }
            }
          }
        })
        .filter((el) => el);
      setCars(tempCars);
    }
  }, [path, vehicleLocations]);

  useEffect(() => {
    if (court !== "rmb" && cars.length > 0) {
      const tempCarPaths = cars.map((el) => {
        const carPath = carPaths.find(
          (ele) => ele.license_plate === el.license_plate
        );

        if (carPath?.lastLog.length > 0 && el?.coordinates.length > 0) {
          const pathLine = turf.lineString(el.path);
          const currentLoc = turf.point(el.coordinates);
          const lastLoc = turf.point(carPath.lastLog);

          const recalSliceRaw = turf
            .lineSlice(lastLoc, currentLoc, pathLine)
            
          const recalSlice = recalSliceRaw.geometry.coordinates.map((el) => ({ lat: el[1], lng: el[0] }));

          if (turf.length(recalSliceRaw)/turf.distance(currentLoc, lastLoc) > 3) {
            // Prevent round trip
            console.log("moving too long");
            return {
              license_plate: el.license_plate,
              value: 0,
              lastLog: el.coordinates,
              path: [
                lastLoc.geometry.coordinates,
                currentLoc.geometry.coordinates
              ].map((el) => ({ lat: el[1], lng: el[0] })),
            };
          } else if (
            el?.coordinates?.[1].toFixed(7) ===
            carPath?.path?.[1]?.lat.toFixed(7)
          ) {
            // "same loc, no move"
            // console.log("slnm");
            return {
              license_plate: el.license_plate,
              value: carPath.value,
              lastLog: carPath.lastLog,
              path: recalSlice,
            };
          }
          //"different loc, move"
          // console.log("dl,m");
          return {
            license_plate: el.license_plate,
            value: 0,
            lastLog: el.coordinates,
            path: recalSlice,
          };
        }
        // "no last log or current log"
        return {
          license_plate: el.license_plate,
          value: 0,
          lastLog: el.coordinates,
          path: [
            { lat: el.coordinates[1], lng: el.coordinates[0] },
            { lat: el.coordinates[1], lng: el.coordinates[0] },
          ],
        };
      });
      // console.log("tempCarPaths", tempCarPaths);
      setCarPaths(tempCarPaths);
    }
  }, [vehicleLocations, cars]);

  useEffect(() => {
    // if (vehicleLocations2) {
    //   const tempCars = Object.values(vehicleLocations2);
    //   setCars2(uniqBy(tempCars, "license_plate"));
    // }
    if (vehicleLocations2 && path2.length > 0) {
      const tempCars = uniqBy(Object.values(vehicleLocations2), "license_plate")
        .map((el) => {
          const pathLine = turf.lineString(path2.map((el) => [el.lng, el.lat]));
          const currentLog = turf.point(el.coordinates);
          const logToLineDistance = turf.pointToLineDistance(
            currentLog,
            pathLine,
            {
              units: "meters",
            }
          );

          // check vehicle location is 100m away from polyline
          if (logToLineDistance < 150 && pathLine) {
            const pathLength = turf.length(pathLine, { units: "meters" });

            if (vehicleLocationAlwaysShow && !el.progress) {
              return {
                ...el,
                coordinates: turf.nearestPointOnLine(
                  pathLine,
                  point(el.coordinates)
                ).geometry.coordinates,
                path: pathLine.geometry.coordinates,
              };
            } else {
              if (el.progress) {
                // check if progress exists, then bind to ±25% (or param) of line
                const start = el.progress - pathLength * 0.15;
                const end = el.progress + pathLength * 0.15;
                const slicedLine = turf.lineSliceAlong(
                  pathLine,
                  start >= 0 ? start : 0,
                  end <= pathLength ? end : pathLength,
                  { units: "meters" }
                );

                const tempCoor = turf.nearestPointOnLine(
                  slicedLine,
                  point(el.coordinates)
                );

                return {
                  ...el,
                  coordinates: tempCoor.geometry.coordinates,
                  path: slicedLine.geometry.coordinates,
                };
              } else {
                const tempCoor = turf.nearestPointOnLine(
                  pathLine,
                  point(el.coordinates)
                );
                return {
                  ...el,
                  coordinates: tempCoor.geometry.coordinates,
                  path: pathLine.geometry.coordinates,
                };
              }
            }
          }
        })
        .filter((el) => el);
      setCars2(tempCars);
    }
  }, [path2, vehicleLocations2]);

  useEffect(() => {
    if (court !== "rmb") {
      const timer = setTimeout(() => {
        if (carPaths.length > 0) {
          setCarPaths(
            carPaths.map((el, index) => {
              let bearing = turf.bearing([el.path[0].lng, el.path[0].lat], [el.path[1].lng, el.path[1].lat]);

              if (el?.value < 100) {
                if (el.value + 5 > 90) {
                  // console.log(el.license_plate, " to 100");
                  setTrigger(false);
                }
                return { ...el, value: el.value + 5, bearing };
              }
              return { ...el, value: el?.value || 0, bearing };
            })
          );
        }
      }, 30);

      return () => clearTimeout(timer);
    }
  }, [carPaths, court, trigger]);

  useEffect(() => {
    if (!isLoaded) {
      setIsLoaded(true);
    }
  }, []);

  const mapStationToRoute = (lat, lng) => {
    const line = lineString(
      path.map((ele) => {
        return [ele.lng, ele.lat];
      })
    );
    const points = point([lng, lat]);
    const snapped = nearestPointOnLine(line, points);
    const [newLng, newLat] = snapped?.geometry?.coordinates;
    return { lat: newLat, lng: newLng };
  };

  return (
    <div style={{ height: "50%", zIndex: "90" }}>
      {/* Map */}
      <GoogleMap
        defaultCenter={{ lat: 22.27544, lng: 114.15253 }}
        onUnM
        ref={map}
        options={{
          minZoom: 10,
          maxZoom: 18,
          streetViewControl: false,
          scaleControl: false,
          mapTypeControl: false,
          panControl: false,
          zoomControl: false,
          rotateControl: false,
          fullscreenControl: false,
        }}
      >
        {/* Route Path Border */}
        <Polyline
          path={path}
          options={{
            strokeColor: `${(court === "rmb" ? "#665B57" : "#3399FF")}`,
            strokeWeight: 8,
            zIndex: "91",
          }}
        />

        {/* Route Path Inner */}
        <Polyline
          path={path}
          options={{
            strokeColor: `${(court === "rmb" ? "#FF8A59" : "#59FF5E")}`,
            strokeWeight: 3,
            zIndex: "101",
          }}
        />

        {/* Traffic Polyline */}
        {traffic.length > 0 &&
          traffic.map((el, index) => {
            const path = decode(el.segment).map((el) => ({
              lat: el[0],
              lng: el[1],
            }));
            return (
              <Polyline
                key={index}
                path={path}
                options={{
                  strokeColor: `${
                    el.trafficLevel === "good"
                      ? "#59FF5E"
                      : el.trafficLevel === "average"
                      ? "#ffac1c"
                      : el.trafficLevel === "bad"
                      ? "#ff1c56"
                      : "#ab3233"
                  }`,
                  strokeWeight: 3,
                  zIndex: "111",
                }}
              />
            );
          })}

        {/* Stops Location */}
        {stops && isLoaded
          ? stops.map((station, index) => {
              return (
                <Marker
                  key={index}
                  position={mapStationToRoute(
                    station?.coordinates.wgs84.latitude,
                    station?.coordinates.wgs84.longitude
                  )}
                  icon={{
                    path: window.google.maps.SymbolPath.CIRCLE,
                    scale: 6,
                    fillOpacity: 1,
                    fillColor: "#FFF",
                    strokeWeight: 4,
                    strokeColor: `${
                      court === "rmb"
                        ? "#cd5c5c"
                        : stopColor
                        ? colors[index]
                        : (themeColour || "#3399ff")
                    }`,
                  }}
                />
              );
            })
          : null}

        {/* Vehicle Icon */}
        {/* {console.log('vehicle',vehicleColor)} */}
        {cars &&
          cars.length > 0 &&
          cars.map((car, index) => {
            /**
             * Disable moving vehicle icons
             * rmb - rmb route is too long & too many stops, long loading time
             * having path2 - currently not available, need time for development to suppoprt vehicles for 2nd route
             */

            // console.log(court === "rmb" || (path2 && path2.length > 0));
            if (
              court === "rmb" ||
              (path2 && path2.length > 0) ||
              vehicleLocationAlwaysShow
            ) {
              if (car?.coordinates) {
                return (
                  // <OverlayView
                  //   position={{
                  //     lat: car?.coordinates?.[1],
                  //     lng: car?.coordinates?.[0],
                  //   }}
                  //   mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                  //   getPixelPositionOffset={() => ({ x: -15, y: -15 })}
                  // >
                  //   <img src={Bus} style={{ height: 30, width: 30 }} />
                  // </OverlayView>
                  <Fragment key={index}>
                    {/* {console.log("vehicleCOlor", vehicleColor)} */}
                    <Marker
                      position={{
                        lat: car?.coordinates?.[1],
                        lng: car?.coordinates?.[0],
                      }}
                      icon={{
                        path: window.google.maps.SymbolPath.CIRCLE,
                        scale: 14,
                        fillOpacity: 1,
                        zIndex: "501",
                        fillColor: vehicleColor ? colors[index] : themeColour || "#3499FE", //backGround Color
                        strokeColor: "#1A73E8",
                        strokeWeight: 2,
                      }}
                    />
                    <Marker
                      position={{
                        lat: car?.coordinates?.[1],
                        lng: car?.coordinates?.[0],
                      }}
                      icon={{
                        path: "m -4.86 -8.66 l 9.72 0 c 1.62 0 2.43 0.81 2.43 2.43 l 0 8.1 l 0 2.43 c 0 1.62 -1.62 1.62 -2.43 1.62 l 0 0.81 c 0 0.81 0 0.81 -0.81 0.81 l -0.81 0 c -0.81 0 -0.81 0 -0.81 -1.62 l -4.86 0 c 0 1.62 0 1.62 -0.81 1.62 l -0.81 0 c -0.81 0 -0.81 0 -0.81 -0.81 l 0 -0.81 c -0.81 0 -2.43 0 -2.43 -1.62 l 0 -0.81 l 0 -1.62 l 0 -8.1 c 0 -1.62 0.81 -2.43 2.43 -2.43 m -0.81 2.43 l 0 4.86 c 4.05 0.81 7.29 0.81 11.34 0 c 0 -1.62 0 -3.24 0 -4.86 c -0.81 -0.81 -10.53 -0.81 -11.34 0 M -6 3 C -6 5 -2 5 -2 2 C -3 2 -6 1 -6 3 M 2 2 C 2 5 6 5 6 3 C 6 1 3 2 2 2",
                        scale: 1,
                        fillOpacity: 1,
                        fillColor: "#FFF", //car color
                        strokeWeight: 0,
                        zIndex: "502",
                      }}
                    />
                    {vehicleIconBearing && !isNil(car.bearing) && (
                      <Marker
                        position={{
                          lat: car?.coordinates?.[1],
                          lng: car?.coordinates?.[0],
                        }}
                        icon={{
                          path: "M -10 -16 L 0 -25 L 10 -16 L 0 -18 L -10 -16",
                          scale: 1,
                          fillOpacity: 1,
                          fillColor: "#3499FE",
                          strokeColor: "#1A73E8",
                          strokeWeight: 2,
                          zIndex: "503",
                          rotation: car.bearing,
                        }}
                      />
                    )}

                    {showLicensePlate && <OverlayView
                      position={{ lat: car.coordinates[1], lng: car.coordinates[0] }}
                      mapPaneName={OverlayView.FLOAT_PANE}
                      getPixelPositionOffset={(w, h) => ({ x: -(w/2), y: 20 })}
                    >
                      <div style={{
                        background: `white`,
                        border: `1px solid #ccc`,
                        zIndex: 10000,
                        padding: 5
                      }}>
                        {car.license_plate}
                      </div>
                    </OverlayView>}
                  </Fragment>
                );
              }
              return <Fragment key={index}></Fragment>;
            } else {
              const offsets = carPaths.find(
                (el) => el.license_plate === car.license_plate
              );
              return <>
              {(!showLicensePlate && offsets?.path.length > 0) ? (
                <Polyline
                  key={index}
                  path={offsets?.path}
                  options={{
                    strokeWeight: 0,
                    // strokeColor: "#f00",
                    strokeOpacity: 1,
                    zIndex: "500",
                    icons: [
                      {
                        icon: {
                          path: window.google.maps.SymbolPath.CIRCLE,
                          scale: 14,
                          fillOpacity: 1,
                          zIndex: "501",
                          fillColor: themeColour || "#3499FE",
                          strokeColor: Color(themeColour || "#3499FE").darken(0.25),
                          strokeWeight: 2,
                        },
                        offset: `${offsets?.value}%`,
                      },
                      {
                        icon: {
                          path: "m -4.86 -8.66 l 9.72 0 c 1.62 0 2.43 0.81 2.43 2.43 l 0 8.1 l 0 2.43 c 0 1.62 -1.62 1.62 -2.43 1.62 l 0 0.81 c 0 0.81 0 0.81 -0.81 0.81 l -0.81 0 c -0.81 0 -0.81 0 -0.81 -1.62 l -4.86 0 c 0 1.62 0 1.62 -0.81 1.62 l -0.81 0 c -0.81 0 -0.81 0 -0.81 -0.81 l 0 -0.81 c -0.81 0 -2.43 0 -2.43 -1.62 l 0 -0.81 l 0 -1.62 l 0 -8.1 c 0 -1.62 0.81 -2.43 2.43 -2.43 m -0.81 2.43 l 0 4.86 c 4.05 0.81 7.29 0.81 11.34 0 c 0 -1.62 0 -3.24 0 -4.86 c -0.81 -0.81 -10.53 -0.81 -11.34 0 M -6 3 C -6 5 -2 5 -2 2 C -3 2 -6 1 -6 3 M 2 2 C 2 5 6 5 6 3 C 6 1 3 2 2 2",
                          scale: 1,
                          fillOpacity: 1,
                          fillColor: "#FFF",
                          strokeWeight: 0,
                          zIndex: "502",
                        },
                        offset: `${offsets?.value}%`,
                        fixedRotation: true,
                      },
                      ...(vehicleIconBearing && !isNil(car.bearing)?[{
                        icon: {
                          path: "M -10 -16 L 0 -25 L 10 -16 L 0 -18 L -10 -16",
                          scale: 1,
                          fillOpacity: 1,
                          fillColor: themeColour || "#3499FE",
                          strokeColor: Color(themeColour || "#1A73E8").darken(0.25),
                          strokeWeight: 2,
                          zIndex: "503",
                          rotation: offsets?.bearing || car.bearing,
                        },
                        offset: `${offsets?.value}%`,
                      }]:[])
                    ],
                  }}
                ></Polyline>
              ) : (
                <Polyline
                  key={index}
                  path={[
                    { lat: car.coordinates[1], lng: car.coordinates[0] },
                    { lat: car.coordinates[1], lng: car.coordinates[0] },
                  ]}
                  options={{
                    strokeWeight: 0,
                    strokeOpacity: 1,
                    zIndex: "500",
                    icons: [
                      {
                        icon: {
                          path: window.google.maps.SymbolPath.CIRCLE,
                          scale: 14,
                          fillOpacity: 1,
                          zIndex: "501",
                          fillColor: themeColour || "#3499FE",
                          strokeColor: themeColour || "#1A73E8",
                          strokeWeight: 2,
                        },
                        offset: `${offsets?.value}%`,
                      },
                      {
                        icon: {
                          path: "m -4.86 -8.66 l 9.72 0 c 1.62 0 2.43 0.81 2.43 2.43 l 0 8.1 l 0 2.43 c 0 1.62 -1.62 1.62 -2.43 1.62 l 0 0.81 c 0 0.81 0 0.81 -0.81 0.81 l -0.81 0 c -0.81 0 -0.81 0 -0.81 -1.62 l -4.86 0 c 0 1.62 0 1.62 -0.81 1.62 l -0.81 0 c -0.81 0 -0.81 0 -0.81 -0.81 l 0 -0.81 c -0.81 0 -2.43 0 -2.43 -1.62 l 0 -0.81 l 0 -1.62 l 0 -8.1 c 0 -1.62 0.81 -2.43 2.43 -2.43 m -0.81 2.43 l 0 4.86 c 4.05 0.81 7.29 0.81 11.34 0 c 0 -1.62 0 -3.24 0 -4.86 c -0.81 -0.81 -10.53 -0.81 -11.34 0 M -6 3 C -6 5 -2 5 -2 2 C -3 2 -6 1 -6 3 M 2 2 C 2 5 6 5 6 3 C 6 1 3 2 2 2",
                          scale: 1,
                          fillOpacity: 1,
                          fillColor: "#FFF",
                          strokeWeight: 0,
                          zIndex: "502",
                        },
                        offset: `${offsets?.value}%`,
                        fixedRotation: true,
                      },
                    ],
                  }}
                ></Polyline>
              )}
              
              {showLicensePlate && <OverlayView
                position={{ lat: car.coordinates[1], lng: car.coordinates[0] }}
                mapPaneName={OverlayView.FLOAT_PANE}
                getPixelPositionOffset={(w, h) => ({ x: -(w/2), y: 20 })}
              >
                <div style={{
                  background: `white`,
                  border: `1px solid #ccc`,
                  zIndex: 10000,
                  padding: 5
                }}>
                  {car.license_plate}
                </div>
              </OverlayView>}
              </>;
            }
          })}

        {/* Route Path Border */}
        {path2 && path2?.length > 0 && (
          <Polyline
            path={path2}
            options={{ strokeColor: "#FF5A60", strokeWeight: 8, zIndex: "90" }}
          />
        )}

        {/* Route Path Inner */}
        {path2 && path2?.length > 0 && (
          <Polyline
            path={path2}
            options={{
              strokeColor: `${(court === "rmb" ? "#ffc9c5" : "#59FF5E")}`,
              strokeWeight: 3,
              zIndex: "100",
            }}
          />
        )}

        {/* Traffic Polyline */}
        {traffic2 &&
          traffic2.length > 0 &&
          traffic2.map((el) => {
            const path = decode(el.segment).map((el) => ({
              lat: el[0],
              lng: el[1],
            }));
            return (
              <Polyline
                path={path}
                options={{
                  strokeColor: `${
                    el.trafficLevel === "good"
                      ? "#59FF5E"
                      : el.trafficLevel === "average"
                      ? "#ffac1c"
                      : el.trafficLevel === "bad"
                      ? "#ff1c56"
                      : "#ab3233"
                  }`,
                  strokeWeight: 3,
                  zIndex: "110",
                }}
              />
            );
          })}

        {/* Stops Location */}
        {stops2
          ? stops2.map((station) => {
              return (
                <OverlayView
                  position={mapStationToRoute(
                    station.coordinates?.wgs84.latitude,
                    station.coordinates?.wgs84.longitude
                  )}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                >
                  <div className={`station-icon ${court}`}></div>
                </OverlayView>
              );
            })
          : null}

        {/* Vehicle Icon */}
        {cars2 && cars2.length > 0
          ? cars2.map((car) => {
              if (car?.coordinates) {
                return (<>
                  <OverlayView
                    position={{
                      lat: car?.coordinates?.[1],
                      lng: car?.coordinates?.[0],
                    }}
                    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                    getPixelPositionOffset={() => ({ x: -15, y: -15 })}
                  >
                    <img src={Bus} style={{ height: 30, width: 30 }} />
                  </OverlayView>

                  {showLicensePlate && <OverlayView
                    position={{ lat: car.coordinates[1], lng: car.coordinates[0] }}
                    mapPaneName={OverlayView.FLOAT_PANE}
                    getPixelPositionOffset={(w, h) => ({ x: -(w/2), y: 20 })}
                  >
                    <div style={{
                      background: `white`,
                      border: `1px solid #ccc`,
                      zIndex: 10000,
                      padding: 5
                    }}>
                      {car.license_plate}
                    </div>
                  </OverlayView>}
                </>
                  
                );
              }
            })
          : null}
      </GoogleMap>
    </div>
  );
});

export default MapComp;
